import styled from "styled-components";
import { BaseButton } from "./button";

export const Form = styled.form`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
`;

export const ErrorMessage = styled.h4`
  background: darkred;
  padding: 16px;
  border-radius: 4px;
  color: white;
  margin: 16px;
`;

export const SuccessMessage = styled.h4`
  background: green;
  padding: 16px;
  border-radius: 4px;
  color: white;
  margin: 16px;
`;

export const Button = styled(BaseButton)`
  width: 142px;
  height: 44px;
  text-transform: uppercase;
  border-radius: 22px;
  font-weight: bold;
  letter-spacing: 1.6px;
`;

export const FormControl = styled.input`
  width: 335px;
  height: 40px;
  border-radius: 4px;
  border: solid 1px rgba(63, 65, 84, 0.2);
  padding: 0 15px;
  margin-top: 5px;
  @media (max-width: 420px) {
    width: 300px;
  }
`;

export const ControlLabel = styled.div`
  letter-spacing: 1px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: row;
  flex-direction: column;
  margin-bottom: 15px;
`;

export const ButtonSubmit = styled.input`
align-items:center;
cursor:pointer;
display: flex;
justify-content:center;
text-align: center;
cursor:pointer;
width: 142px;
height: 44px;
text-transform: uppercase;
border-radius: 22px;
font-weight: bold;
letter-spacing: 1.6px;
background-color: #5b8926;
color: #fff;
border: none;
&:hover {
    box-shadow: 0 6px 7px 0 rgba(199,199,199,1);
  }
&:disabled,
button[disabled]{
  background-color: grey
  color: white;
  cursor: not-allowed;
}
`;



// WEBPACK FOOTER //
// ./src/styles/form.js